import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import UserTableList from "./list/list";
import PaginationSection from "../../components/pagination/pagination";
import { useDispatch } from "react-redux";
import AddUser from "../../components/adduser/adduser";

const Users = () => {
  var defaultInput = {
    input: { search: "", limit: 10, status: 0 },
    isSubmited: true,
  };
  const [inputValues, setSetInputValues] = useState(defaultInput);

  const [offset, setOffset] = useState(0);

  const handleCallback = (childData) => {
    setOffset(childData);
  };

  const dispatch = useDispatch();

  const handleChange = (e) => {
    let input = inputValues.input;
    input[e.target.name] = e.target.value;
    setSetInputValues({ input: input, isSubmited: false });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setSetInputValues((prev) => ({ ...prev, isSubmited: true }));
    setOffset(0);
    dispatch({
      type: "PAGINATION",
      payload: { per_page: inputValues.input.limit, page: "user" },
    });
  };

  const handleUserCallback = (childData) => {
    console.log("handleUserCallback", childData);
  };

  const reset = () => {
    setSetInputValues(defaultInput);
    dispatch({ type: "PAGINATION", payload: { per_page: 10, page: "user" } });
  };

  const [openBlock, setBlockOpen] = useState(false);
  const handleBlockClickOpen = () => {
    setBlockOpen(true);
  };

  const [open, setOpen] = useState(false);
  return (
    <div className="user-wrap">
      <div className="filter-area">
        <form onSubmit={handleSubmit}>
          <div className="filter-top-content">
            <div className="search-box">
              <TextField
                type="text"
                name="search"
                onChange={handleChange}
                value={inputValues.input.search}
                placeholder="Search by Name ,Email ID"
              />
            </div>
            <div className="select-box mr-15">
              <FormControl fullWidth>
                <Select
                  onChange={handleChange}
                  value={inputValues.input.status}
                  name="status"
                  displayEmpty
                >
                  <MenuItem value={0}>Select User Type</MenuItem>
                  <MenuItem value={2}>Villager</MenuItem>
                  <MenuItem value={1}>Village Owner</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="select-box">
              <FormControl fullWidth>
                <Select
                  value={inputValues.input.limit}
                  onChange={handleChange}
                  name="limit"
                  displayEmpty
                >
                  <MenuItem value={10}>Show 10</MenuItem>
                  <MenuItem value={50}>Show 50</MenuItem>
                  <MenuItem value={70}>Show 70</MenuItem>
                  <MenuItem value={100}>Show 100</MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>
          <div className="btn-area">
            <Button variant="contained" type="submit">
              Apply
            </Button>
            <div className="reset-btn mr-15">
              <Button variant="outlined" color="error" onClick={reset}>
                Reset
              </Button>
            </div>

            <div className="ml-auto">
              <Button
                variant="contained"
                type="submit"
                onClick={() => handleBlockClickOpen()}
              >
                {" "}
                Add User
              </Button>
            </div>
          </div>
        </form>
      </div>
      <div className="main-section-wrap">
        <UserTableList
          data={inputValues}
          parentUserCallback={handleUserCallback}
          offset={offset}
          page="userList"
        />
        <PaginationSection
          parentCallback={handleCallback}
          page="userList"
          data={offset}
        />

        <AddUser open={openBlock} setOpen={setBlockOpen} />
      </div>
    </div>
  );
};

export default Users;
